import { useEffect, useMemo, useRef, useState } from 'react';
import { API_BASE_URL } from '../../config/api';

const toParagraphs = (value) => (
  String(value || '')
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
);

export default function PolicyDocumentPage({ type, title, eyebrow, emptyMessage }) {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const documentRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const loadPolicy = async () => {
      setLoading(true);
      setError('');

      try {
        const response = await fetch(`${API_BASE_URL}/api/policies/${type}`);
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(payload?.message || 'Unable to load policy.');
        }

        if (!cancelled) {
          setPolicy(payload?.policy || null);
        }
      } catch (loadError) {
        if (!cancelled) {
          setError(loadError.message || 'Unable to load policy.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadPolicy();
    return () => {
      cancelled = true;
    };
  }, [type]);

  const paragraphs = useMemo(() => toParagraphs(policy?.text), [policy]);

  return (
    <section className="policy-page-shell">
      <div className="policy-page-hero">
        <p className="policy-page-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
      </div>

      {loading ? <div className="policy-state-card">Loading policy...</div> : null}
      {!loading && error ? <div className="policy-state-card policy-state-card-error">{error}</div> : null}
      {!loading && !error && !policy ? <div className="policy-state-card">{emptyMessage}</div> : null}

      {!loading && !error && policy ? (
        <article ref={documentRef} className="policy-document-card">
          <div className="policy-document-header">
            <div>
              <p className="policy-document-label">Published policy</p>
              <h2>{title}</h2>
            </div>
          </div>

          {paragraphs.length > 0 ? (
            <div className="policy-document-body">
              {paragraphs.map((paragraph, index) => (
                <p key={`${type}-${index}`}>{paragraph}</p>
              ))}
            </div>
          ) : (
            <div className="policy-state-card">No text is available for this policy yet.</div>
          )}
        </article>
      ) : null}
    </section>
  );
}